export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
  callbackUrl: `${globalThis.location.origin}/auth`,
  logoutUrl: `${globalThis.location.origin}/hello`,
};
